import { formatDate } from "@/utils/formateData";

interface ReceiveConfirmationProps {
  onConfirm: () => void;
  expected_delivery_date: Date;
  loading: boolean;
}

export const ReceiveConfirmation = ({
  onConfirm,
  expected_delivery_date,
  loading,
}: ReceiveConfirmationProps) => {
  return (
    <div className="mt-4 border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-gray-500">Expected Delivery Date</p>
          <p className="text-sm font-medium text-gray-700">
            {formatDate(String(expected_delivery_date)) || ""}
          </p>
        </div>

        <button
          onClick={onConfirm}
          disabled={loading}
          className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md text-sm flex items-center gap-2 disabled:opacity-50"
        >
          ✔ Yes, I Received It
        </button>
      </div>

      <p className="text-[11px] text-gray-400 mt-1">
        *The delivery date is approximate and may vary based on logistics.
      </p>
    </div>
  );
};
